/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RoleFilters {
    getFixupPrototypeFunction() { return RoleFilters.fixupPrototype; }

    static newInstance(model: Partial<RoleFilters>): RoleFilters {
        let obj = Object.assign(new RoleFilters(), model);
        RoleFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RoleFilters>): RoleFilters {
        if (!model) return null;
        return RoleFilters.newInstance(<RoleFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RoleFilters) {
        if (!obj) return;

        models.RoleFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RoleFilters): boolean {
        Object.setPrototypeOf(obj, RoleFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Text search across role name, description and category
     */
    search: string;

    /**
     * Filter by role status
     */
    status: models.RoleStatus;

    /**
     * Filter by role category (default or custom)
     */
    category: models.RoleCategory;

    /**
     * Filter by master account ID
     */
    master_account_id: string;

    /**
     * Filter by tenant ID
     */
    tenant_id: string;

}
